import { Promotions } from 'src/client/appTypings';
import { createAction } from '@reduxjs/toolkit';

export const updatePromotionsAction = createAction<Promotions>(
  'promotion/updatePromotions'
);
